import './settings-leaf.css';
import { useTranslation } from 'react-i18next';
import type { Company } from '@shared/types/index.ts';
import { dustPolicySchema } from '@shared/dust-evidence.ts';
import { useCompanyCardForm, CardSaveFooter } from './company-card-form.tsx';
import { Checkbox } from '../ui.tsx';
import { NumberInput } from '../number-input.tsx';
const snapshot = (company: Company) => ({ dustPolicy: company.dustPolicy ?? null });
const payload = (draft: ReturnType<typeof snapshot>) => draft;
export default function DustPolicyCard() {
  const { t } = useTranslation();
  const form = useCompanyCardForm(snapshot, payload);
  if (!form.draft) return null;
  const policy = form.draft.dustPolicy;
  const valid = policy === null || dustPolicySchema.safeParse(policy).success;
  return (
    <section className="card work-section settings-leaf mb-6">
      <div className="work-section-heading">
        <h2 className="text-lg font-semibold">{t('dust.settingsHeading')}</h2>
      </div>
      <p>{t('dust.settingsHint')}</p>
      <Checkbox
        label={t('dust.enable')}
        checked={policy !== null}
        disabled={form.readOnly || form.saving}
        onChange={(e) => form.set('dustPolicy', e.target.checked ? { upliftBasisPoints: null } : null)}
      />
      {policy && (
        <NumberInput
          label={t('dust.rate')}
          min={0.01}
          max={100}
          step={0.01}
          value={policy.upliftBasisPoints === null ? null : policy.upliftBasisPoints / 100}
          disabled={form.readOnly || form.saving}
          onValueChange={(value) =>
            form.set('dustPolicy', { upliftBasisPoints: value === null ? null : Math.round(value * 100) })
          }
        />
      )}
      <CardSaveFooter
        saveLabel={t('dust.savePolicy')}
        form={{
          ...form,
          error: valid ? form.error : t('dust.invalid'),
          submit: () => {
            if (valid) form.submit();
          },
        }}
      />
    </section>
  );
}
